import React from "react";

const EmptyCircle = ({ size= 48 }) => (<svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle id="Ellipse 426" cx="24" cy="24" r="24" fill="#2D2C44" fillOpacity="0.08"/>
</svg>);

export default EmptyCircle;
